export var getPublicKey = function (roaster) {
    if (roaster.country.isEurope)
        return "".concat(STRIPE_EUROPE_PUBLIC_API_KEY);
    if (roaster.country.code === 'US')
        return "".concat(STRIPE_US_PUBLIC_API_KEY);
    return "".concat(STRIPE_JAPANESE_PUBLIC_API_KEY);
};
